import { Link } from "react-router-dom";
import { useApp } from "@/lib/AppContext";

const T = {
  ar: {
    badge: "من نحن",
    title: "مغاسل القمر الأبيض",
    p1: "نحن رائدون في مجال خدمات الغسيل والتنظيف الاحترافي، نقدم خدماتنا بأعلى معايير الجودة والنظافة لعملائنا الكرام.",
    p2: "منذ انطلاقنا، نسعى دائماً لتوفير تجربة استثنائية تجمع بين الراحة والجودة والأسعار المناسبة، مع ضمان وصول ملابسك نظيفة ومعطّرة في أسرع وقت.",
    value1: "جودة عالية", value2: "نظافة فائقة", value3: "سرعة في التوصيل",
    cta: "تواصل معنا",
    stats: [
      { v: "5+", l: "سنوات خبرة" },
      { v: "1000+", l: "عميل راضٍ" },
      { v: "98%", l: "نسبة رضا العملاء" },
    ]
  },
  en: {
    badge: "About Us",
    title: "White Moon Laundry",
    p1: "We are leaders in professional laundry and cleaning services, delivering the highest standards of quality and cleanliness to our valued customers.",
    p2: "Since our launch, we've always strived to provide an exceptional experience combining convenience, quality, and competitive prices, ensuring your clothes return clean and fresh in the shortest time.",
    value1: "High Quality", value2: "Superior Cleanliness", value3: "Fast Delivery",
    cta: "Contact Us",
    stats: [
      { v: "5+", l: "Years Experience" },
      { v: "1000+", l: "Happy Customers" },
      { v: "98%", l: "Satisfaction Rate" },
    ]
  }
};

export default function AboutSection() {
  const { lang } = useApp();
  const tr = T[lang] || T.ar;
  const isAr = lang === "ar";

  return (
    <section id="about" className="py-20 bg-background" dir={isAr ? "rtl" : "ltr"}>
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Visual */}
          <div className="order-2 lg:order-1 relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1604335399105-a0c585fd81a1?w=600&h=400&fit=crop&fm=webp&q=80"
                alt="laundry background"
                loading="lazy"
                decoding="async"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-[#1E5FA8]/85 to-[#0e3060]/90" />
              <div className="relative z-10 p-6 space-y-4">
                {/* Stats */}
                <div className="grid grid-cols-3 gap-3">
                  {tr.stats.map((s, i) => (
                    <div key={i} className="bg-white/10 backdrop-blur rounded-2xl py-4 px-2 flex flex-col items-center justify-center">
                      <p className="text-2xl sm:text-3xl font-black text-white tracking-tight leading-none">{s.v}</p>
                      <p className="text-[10px] sm:text-xs text-white/80 font-semibold mt-1.5 text-center leading-tight">{s.l}</p>
                    </div>
                  ))}
                </div>
                {/* Values */}
                <div className="grid grid-cols-1 gap-2">
                  {[tr.value1, tr.value2, tr.value3].map((v, i) => (
                    <div key={i} className="flex items-center gap-2 bg-white/10 backdrop-blur rounded-xl px-4 py-2.5">
                      <span className="w-5 h-5 bg-white/20 rounded-full flex items-center justify-center text-white text-[10px] flex-shrink-0">✓</span>
                      <span className="text-sm font-bold text-white">{v}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Text */}
          <div className="order-1 lg:order-2 space-y-5">
            <span className="inline-block bg-primary/10 text-primary text-xs font-black px-4 py-2 rounded-full">
              {tr.badge}
            </span>
            <h2 className="text-3xl lg:text-4xl font-black text-foreground leading-tight">{tr.title}</h2>
            <p className="text-muted-foreground leading-relaxed">{tr.p1}</p>
            <p className="text-muted-foreground leading-relaxed">{tr.p2}</p>
            <Link to="/laundry"
              className="inline-flex items-center gap-2 bg-primary text-primary-foreground font-bold px-6 py-3 rounded-xl hover:opacity-90 transition-all shadow-md">
              🧺 {tr.cta}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}